/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Wizard_Step3_Embedding_TitleInputs */



/**
* | output |
* | --- |
* | "Embedding settings" |
*
* @param {Spaces_Wizard_Step3_Embedding_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_wizard_step3_embedding_title = /** @type {((inputs?: Spaces_Wizard_Step3_Embedding_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Wizard_Step3_Embedding_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Embedding-Einstellungen")
	return /** @type {LocalizedString} */ ("Embedding settings")
});